export interface IOrderState {
  orderId: number;
  orderState: EOrderState;
}

export enum EOrderState {
  Unknown = 'Unknown',
  Initialized = 'Initialized',
  Complete = 'Complete',
  Failed = 'Failed',
}
